import { render } from "./RegistrationApprenticeSalaryTableComponent.vue?vue&type=template&id=94547f46&scoped=true"
import script from "./RegistrationApprenticeSalaryTableComponent.vue?vue&type=script&lang=js"
export * from "./RegistrationApprenticeSalaryTableComponent.vue?vue&type=script&lang=js"

import "./RegistrationApprenticeSalaryTableComponent.vue?vue&type=style&index=0&id=94547f46&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94547f46"]])

export default __exports__